import React, { useEffect, useState } from "react";
import { Table } from "antd";
import Header from '../Header';
import Sidebar from '../Sidebar';
import { onShowSizeChange, itemRender } from '../Pagination';
import {
  imagesend, pdficon, pdficon3, pdficon4, plusicon, refreshicon, searchnormal
} from '../imagepath';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { gethospital } from "../../services/admin/hospital/hospital";
import { SearchOutlined } from '@ant-design/icons';

const HospitalList = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const fetchHospitals = async () => {
    try {
      const result = await gethospital();
      if (result.success) {
        // Transform the hospital data if needed to fit the table structure
        const formattedData = result.data.map((item, index) => ({
          id: item.id || index,
          Name: item.name,
          Email: item.email,
          mobile: item.mobile,
          address: item.address,
          city: item.city,
          state: item.state,
          country: item.country,
          pincode: item.pincode,
          no_of_days: item.no_of_days,
          how_many_create_receptionist: item.how_many_create_receptionist,
          how_many_create_pharmacy: item.how_many_create_pharmacy,
          start_date: item.start_date || "N/A",
          end_date: item.end_date || "N/A",
          bill_no_sequence_prefix: item?.hospital_setting?.bill_no_sequence_prefix,
          bill_no_sequence_start: item?.hospital_setting?.bill_no_sequence_start,
          bill_receipt_no_start: item?.hospital_setting?.bill_receipt_no_start,
        }));
        console.log("Formatted Data:", formattedData);
        setDataSource(formattedData);
      } else {
        console.error("Error:", result.error || "Failed to fetch hospitals");
      }
    } catch (err) {
      console.error("Exception:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHospitals();
  }, []);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.length - b.Name.length,
      render: (text, record) => (
        <h2 className="profile-image">
          <Link to="#">{record.Name}</Link>
        </h2>
      ),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a, b) => a.Email.length - b.Email.length,
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      sorter: (a, b) => a.mobile.length - b.mobile.length,
      render: (text, record) => <Link to="#">{record.mobile}</Link>,
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      sorter: (a, b) => a.start_date.length - b.start_date.length,
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      sorter: (a, b) => a.end_date.length - b.end_date.length,
    },
    {
      title: "",
      render: (text, record) => (
        <div className="text-end">
          <div className="dropdown dropdown-action">
            <Link to="#" className="action-icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              <i className="fas fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-end">
              <Link className="dropdown-item" to="/hospitalprofile"  state={{ hospital: record }}>
                <i className="fa-solid fa-user-doctor me-2"></i> View Profile
              </Link>
             <Link
                className="dropdown-item"
                to="/edithospital"
                state={{ hospital: record }}
              >
                <i className="far fa-edit me-2" /> Edit
              </Link>

              <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_patient">
                <i className="fa fa-trash-alt me-2"></i> Delete
              </Link>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <Header />
      <Sidebar activeClassName="hospital" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/hospitallist">Hospitals</Link></li>
                  <li className="breadcrumb-item"><FeatherIcon icon="chevron-right" /></li>
                  <li className="breadcrumb-item active">Hospitals List</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Hospitals List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <input type="text" className="form-control" placeholder="Search here" />
                                <Link className="btn" style={{color:"#2e37a4",fontWeight: "bold"}}>
                            <SearchOutlined style={{ fontSize: "18px",fontWeight: "bold" }}/>
                            </Link>
                              </form>
                            </div>  
                            
                            <div className="add-group">
                              <Link to="/add-hospital" className="btn btn-primary add-pluss ms-2">
                                <img src={plusicon} alt="#" />
                              </Link>
                              <button onClick={fetchHospitals} className="btn btn-primary doctor-refresh ms-2">
                                <img src={refreshicon} alt="#" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-auto text-end float-end ms-auto download-grp">
                        <Link to="#" className="me-2"><img src={pdficon} alt="#" /></Link>
                        <Link to="#" className="me-2"><img src={pdficon3} alt="#" /></Link>
                        <Link to="#"><img src={pdficon4} alt="#" /></Link>
                      </div> */}
                    </div>
                  </div>

                  <div className="table-responsive doctor-list">
                    <Table
                      loading={loading}
                      pagination={{
                        total: dataSource.length,
                        showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        onShowSizeChange: onShowSizeChange,
                        itemRender: itemRender,
                        style: { paddingRight: "14px" },
                      }}
                      columns={columns}
                      dataSource={dataSource}
                      rowSelection={rowSelection}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>

      {/* Delete Modal */}
      <div id="delete_patient" className="modal fade delete-modal" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src={imagesend} alt="#" width={50} height={46} />
              <h3>Are you sure want to delete this ?</h3>
              <div className="m-t-20">
                <Link to="#" className="btn btn-white me-2" data-bs-dismiss="modal">Close</Link>
                <button type="submit" className="btn btn-danger">Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HospitalList;
